import {
  RL_EMPTY_UNLOCKED_EMAIL,
  RL_PLACE_ORDER_RECAPTCHA,
  SVP_RL_1272_RECIPIENT_SURVEY,
  SVP_COMBINABLE_RLS,
  SVP_RL_HIDE_FOOTER_LINKS,
  SVP_ADA_CHATBOT_ENABLED,
  USE_NEW_REWARD_CARD,
  RL_HIGH_VOLUME_WARNING,
  RX_ADA_PROACTIVE,
  RLSF_DATADOG_RUM_METRICS,
  RX_DISB_LINK,
  RX_DISABLE_DISB_LINK
} from '@/plugins/split/ActiveSplits'

// All local splits are 'on' or 'off' unless otherwise specified
export const LocalOnlyFeatures = {
  [RL_EMPTY_UNLOCKED_EMAIL]: 'off',
  [RL_PLACE_ORDER_RECAPTCHA]: 'off',
  [SVP_RL_1272_RECIPIENT_SURVEY]: 'on',
  [SVP_COMBINABLE_RLS]: 'on',
  [SVP_RL_HIDE_FOOTER_LINKS]: 'off',
  [SVP_ADA_CHATBOT_ENABLED]: 'on',
  [USE_NEW_REWARD_CARD]: 'on',
  [RL_HIGH_VOLUME_WARNING]: 'off',
  [RX_ADA_PROACTIVE]: 'off',
  [RLSF_DATADOG_RUM_METRICS]: 'on',
  [RX_DISB_LINK]: 'on',
  [RX_DISABLE_DISB_LINK]: 'off'
}
